export default __webpack_public_path__ + "static/media/ci-front.884d8497.svg";